import { UPDATE_PUSH_NOTIFICATION_EVENT } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_PUSH_NOTIFICATION_EVENT:
            return action.payload
        default:
            return state
    }
}
